import React, { useState, useEffect } from "react";

function DebounceExample() {
   const [query, setQuery] = useState("");
   const [debouncedQuery, setDebouncedQuery] = useState("");

   const [isLoading, setIsLoading] = useState(false);
   const [userList, setUserList] = useState([]);

   const searchUser = async (searchText) => {
      try {
         if (!debouncedQuery.trim()) {
            setUserList([]);
            return;
         }
         setIsLoading(true);
         const response = await fetch(
            "https://dummyjson.com/users/search?q=" + searchText,
         );
         if (response.ok) {
            const data = await response.json();
            setUserList(data.users);
         }
         if (!response.ok) {
            throw new Error("Failed to fetch users");
         }
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false);
      }
   };

   useEffect(() => {
      const timer = setTimeout(() => {
         setDebouncedQuery(query);
      },500);
      return () => {
        clearTimeout(timer);
      };
   }, [query]);

   useEffect(() => {
      searchUser(debouncedQuery);
   }, [debouncedQuery]);

   return (
      <>
         <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search..."
         />
         {isLoading && <h5>Loading...</h5>}
         {!isLoading && debouncedQuery && userList.length === 0 && (
            <p>No users found</p>
         )}
         <ul>
            {userList?.map((user) => (
               <li key={user.id}>{user.firstName}</li>
            ))}
         </ul>
      </>
   );
}
export default DebounceExample;
